"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.center = void 0;
const easing_1 = require("ol/easing");
async function center(map, extent, duration = 700, padding) {
    // https://openlayers.org/en/latest/apidoc/module-ol_View-View.html#fit
    // NOTE: Old padding was [100, 100, 100, 100]
    await map.getView().fit(extent, { duration: duration, easing: easing_1.easeOut, padding: [200, 200, 200, 200] });
}
exports.center = center;
